import {useQuery} from '@tanstack/react-query'

import {QueryKeyName} from '../../common/backend'
import {getRefLinks} from '../../common/backend/referenceLinks'

export const useRefLinks = () => {
  return useQuery({queryKey: [QueryKeyName.GetRefLinks], queryFn: () => getRefLinks()})
}
